// LinkedIn bloqueia a página normal do post em iframe (X-Frame-Options), mas
// disponibiliza um endpoint de embed público próprio para esse fim:
// https://www.linkedin.com/embed/feed/update/urn:li:<tipo>:<id>
// Este helper detecta links de post do LinkedIn e reescreve a URL para essa
// forma embutível, extraindo o URN de dentro do link original.

const LINKEDIN_URN_PATTERN = /urn:li:(activity|share|ugcPost):(\d+)/i;
const LINKEDIN_SLUG_ACTIVITY_PATTERN = /activity-(\d+)-/;

const isLinkedInHostname = (hostname: string): boolean => {
    return hostname === 'linkedin.com' || hostname.endsWith('.linkedin.com');
};

export function toLinkedInEmbedUrl(url: string): string | null {
    let hostname: string;
    try {
        hostname = new URL(url).hostname;
    } catch {
        return null;
    }
    if (!isLinkedInHostname(hostname)) return null;

    const urnMatch = url.match(LINKEDIN_URN_PATTERN);
    if (urnMatch) {
        const [, type, id] = urnMatch;
        return `https://www.linkedin.com/embed/feed/update/urn:li:${type}:${id}`;
    }

    const slugMatch = url.match(LINKEDIN_SLUG_ACTIVITY_PATTERN);
    if (slugMatch) {
        return `https://www.linkedin.com/embed/feed/update/urn:li:activity:${slugMatch[1]}`;
    }

    return null;
}
